import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionManagerService } from '@ops/shared-types';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private sessionService: SessionManagerService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const userAuthenticated = this.sessionService.getUser();
    const userRole = this.sessionService.getUserRole(); // Retrieve user role
    const requiredRoles = route.data['roles'] as string[]; // Get roles from route data

    if (userAuthenticated?.accessToken) {
      // if(!userAuthenticated.companies)
      if (!userAuthenticated.companies) {
        const status = route.queryParamMap.get('status');

        if (status === 'success') {
          this.router.navigate(['/welcome']);
        }

        this.router.navigate(['/subscription']);

        // this.router.navigate(['/settings/subscription'])
        // this.router.navigate(['/welcome']);
      } else if (requiredRoles.includes(userRole)) {
        return true;
      } else {
        // Redirect to unauthorized page or login
        this.router.navigate(['/dashboard']);
        return false;
      }
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
